import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';

import * as rawJSONSchemaModuleSurgeryGeneral from '../../schemas/module-surgery-general.json';

class ModuleValueSurgeryGeneral extends ModuleValueGeneral {
  date_of_birth?: string;
  date_of_surgery?: string;
}

export class SchemaModuleSurgeryGeneral extends SchemaModuleGeneral<ModuleValueSurgeryGeneral> {
  schema: JSONSchema<ModuleValueSurgeryGeneral>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModuleSurgeryGeneral );
  }

  hook( form: FormComponent ) {
    super.hook( form );
  }

  setupValidators() {
    super.setupValidators();

    this.validatorDateComparison( 'date_of_surgery', 'date_of_birth', '>' );

    this.validatorDate( 'date_of_birth', ( new Date() ), '<=' , v => new Date( v as any ));
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-surgery-general.ts